// extracted by mini-css-extract-plugin
export default {"TextPlaceholder":"assignees-renderer-module__TextPlaceholder--aFMEp"};